module.exports = __webpack_public_path__ + "static/img/israelToday.832eb26.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/costumers/IsraelToday/israelToday.png
// module id = xjbN
// module chunks = 0